import { jsx as _jsx } from "react/jsx-runtime";
import Box from "@mui/material/Box";
import { styled } from "@mui/material/styles";
import { useMediaQuery } from "@mui/system";
import { useCsAttribute } from "@plansoft-configuration-renderer/framework";
import { useLayoutGridSettingsContext } from "@plansoft-configuration-renderer/layout";
import { useConfigurationAttributeScrolling } from "../NavigationState/useConfigurationScrolling";
/**
 * Wrapper for attributes with support for theming
 */
const MuiAttributeWrapper = styled(Box, {
    name: "MuiAttributeWrapper",
    slot: "root",
    shouldForwardProp: (prop) => prop !== "isAllowed",
})(({ theme, isAllowed }) => (Object.assign({ marginTop: theme.spacing(1), marginBottom: theme.spacing(1), rowGap: theme.spacing(1) }, (!isAllowed && {
    pointerEvents: "none",
    opacity: 0.75,
}))));
const MuiAttributeWrapperCssGrid = styled(MuiAttributeWrapper, {
    name: "MuiAttributeWrapperCssGrid",
    slot: "root",
})({
    display: "grid",
    gridTemplateColumns: "subgrid",
    gridTemplateRows: "subgrid",
    gridColumn: `1 / -1`,
    gridRow: `1 / -1`,
});
const MuiAttributeWrapperFlexbox = styled(MuiAttributeWrapper, {
    name: "MuiAttributeWrapperCssGrid",
    slot: "root",
})({
    display: "flex",
    flexDirection: "column",
});
/**
 * Generic wrapper for attributes
 *
 * Wraps attribute headline and control element
 */
export function AttributeWrapper(props) {
    const { id, isAllowed, path, isComplete, isRequired } = useCsAttribute();
    const elementRef = useConfigurationAttributeScrolling();
    const { flexLayoutBreakpoint, gridMode } = useLayoutGridSettingsContext();
    const matchesFlexLayoutBreakpoint = useMediaQuery((theme) => theme.breakpoints.down(flexLayoutBreakpoint));
    const Component = gridMode === "CssGrid" && !matchesFlexLayoutBreakpoint
        ? MuiAttributeWrapperCssGrid
        : MuiAttributeWrapperFlexbox;
    return (_jsx(Component, { ref: elementRef, id: path, isAllowed: isAllowed, className: "attribute-wrapper", "data-is-complete": isComplete, "data-is-required": isRequired, "data-attribute-path": path, "data-attribute-id": id, sx: props.wrapperSx, children: props.children }));
}
//# sourceMappingURL=AttributeWrapper.js.map